import Head from "next/head";
import type { InferGetServerSidePropsType, GetServerSideProps } from 'next';
import EmbedForm from "@/components/embedForm";
import mentors from "@/constatns/mentors"
import React, { useEffect, useState } from "react";
import "./request.scss"
import SuccessfullSubmit from "../../../../public/icons/successfull-sumbmit.svg";
import Link from "next/link";
import ChevronDown from "../../../../public/icons/chevronDown.svg";

const mentorsId = {
    "niloufar-karimian": "w48ELB",
    "samira-soltani": "3NAlgb",
    "shaygan-hooshyari": "wAl20N",
    "faezeh-davari": "wkYepj",
    "reyhane-seraji": "wvNep8",
    "amin-bahiraee": "mKM5gK",
    "alireza-khaleghi": "npLyME",
    "farbod-ahmadian": "waxdV2",
    "aref-ahmadi": "3xQbZk",
    "soheil-ebrahimi": "mOPNvg",
    "soroush-owji": "3ELbZ2",
    "pooria-khavasi": "wMLoZg",
    "romina-rahimipour": "3XEZAd",
    "parnian-seifi": "mVVbxM",
    "mohammadreza-abdoli": "wQkkQY"
}
export const getServerSideProps: GetServerSideProps<{ name: string }> = async (context) => {
    const name = Array.isArray(context.params?.slug) ? context.params.slug[0] : context.params?.slug || '';
    const mentor = mentors.filter(mentor => mentor.fullName.toLowerCase() === name.split("-").join(" "))
    if (!mentor.length) {
        return {
            redirect: {
                destination: '/mentors',
                permanent: false,
            },
        };
    }
    return { props: { name } };
}
export default function Index({ name, }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    // @ts-ignore
    const mentorId = mentorsId[name];
    const [isLoading, setIsLoading] = useState(true)
    useEffect(() => {
        setTimeout(() => setIsLoading(!isLoading), 5000)
    }, []);

    return (
        <>
            <Head>
                <title>Request a session with {name.split('-').join(" ")}</title>
                <link rel="canonical" href={`https://expatpie.com/mentor/${name}/request`} />
                <meta property="og:title" content="Request a session" />
                <meta property="og:site_name" content="Expat Pie" />
                <meta property="og:description" content="Apply for personalized mentorship to refine your resume, prepare for interviews, and enhance your professional skills for a successful relocation." />
                <meta name="description" content="Apply for personalized mentorship to refine your resume, prepare for interviews, and enhance your professional skills for a successful relocation." />
                <meta property="og:url" content={`https://expatpie.com/mentor/${name}/request`} />
            </Head>
            {mentorId ? <main className="min-h-screen pt-6 pb-[120px]">
                <div className="flex flex-col items-center">
                    {isLoading && <div className="load-bar relative w-full h-1 bg-white-68">
                        <div className="bar inline absolute w-0 h-full left-1/2 text-center content-['']"></div>
                        <div className="bar inline absolute w-0 h-full left-1/2 text-center content-['']"></div>
                    </div>}
                    <EmbedForm id={mentorId} />
                </div>
            </main> : <main className="min-h-screen font-barlow"><div className="flex flex-col items-center justify-center min-h-[inherit]">
                <div className="flex flex-col items-center justify-center lg:w-4/5 lg:max-w-[1103px] px-9 pb-11 lg:bp-16 mt-11 lg:mt-0">
                    <SuccessfullSubmit />
                    <h1 className="mt-10 text-42 text-white font-semibold text-center">The mentor's schedule is fully booked until September.</h1>
                    <p className="text-white-68 mt-4 text-lg text-center">Due to high demand, the mentor's appointments are booked solid until September. Please check back for availability after that.</p>
                    <Link href="/" className="mt-6">
                        <button className="text-base font-semibold py-2 px-4 text-white border border-black flex items-center">
                            Back to home
                            <ChevronDown className="-rotate-90 stroke-white-100 ml-1" />
                        </button>
                    </Link>
                </div>
            </div></main>}
        </>
    );
}
